const AUTH_SERVER_URL = 'https://auth.documedias.com/';

const AUTH_SERVER_FRONTEND_KEY = process.env.VUE_APP_AUTH_SERVER_FRONTEND_KEY;
const API_URL = process.env.VUE_APP_API_URL;

const CONGRESS = process.env.VUE_APP_CONGRESS;
const CONGRESS_ID = process.env.VUE_APP_CONGRESS_ID;

const SUBMISSION_SYSTEM_URL = 'https://' + process.env.VUE_APP_CONGRESS + '.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const FILE_SERVER_URL = 'https://fileserver.documedias.com/';
const FILE_SERVER_FOLDER = '2c332516-a4d4-11ea-bb37-0242ac130002';

const MAILING_IMAGE_MAX_SIZE = 5242880;
const MAILING_IMAGE_ALLOWED_TYPES = ['image/png', 'image/jpeg'];

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  API_URL,
  CONGRESS,
  CONGRESS_ID,
  SUBMISSION_SYSTEM_URL,
  FILE_SERVER_URL,
  FILE_SERVER_FOLDER,
  MAILING_IMAGE_MAX_SIZE,
  MAILING_IMAGE_ALLOWED_TYPES,
}
